module.exports = __webpack_public_path__ + "img/logo.c022cc87.svg";